module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jobContainer"
  }, [_c('h3', [_vm._v("招商加盟")]), _vm._v(" "), _c('div', {
    staticClass: "desctxt"
  }, [_vm._v("\n                我们配备了全套高端台球器材，从经典木质球杆到现代科技复合材质，无论是初学者还是资深高手，都能在这里找到最适合自己的“武器”。更有专业教练团队驻场，提供一对一指导服务，无论是技巧提升、战术分析还是心理辅导，都能让您在短时间内实现球技的飞跃\n            ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src2,
      "alt": ""
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "id": "jobH3"
    }
  }, [_vm._v("一些人等着被世界改变"), _c('br'), _vm._v("而我们已经在"), _c('br'), _vm._v("改变世界")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1adbda06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobContent.vue
// module id = 158
// module chunks = 1